module.exports = __webpack_public_path__ + "static/img/305.a572d5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/305.png
// module id = I3g5
// module chunks = 0